<template>
    <v-btn size="small" :to="to" @click="emit('click')" :href="href" target="_stripe" class="stripeButton">
        <template v-slot:prepend>
            <img src="../../assets/stripe-icon.svg" class="icon" />
        </template>
        Stripe
    </v-btn>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

defineProps({
    title: {
        type: String,
        required: false,
        default: 'View on Stripe'
    },
    to: {
        type: Object as PropType<RouteLocationRaw>,
        required: false
    },
    href: {
        type: String,
        required: false
    }
})

const emit = defineEmits<{
    (event: 'click'): void
}>()
</script>

<style scoped lang="scss">
.stripeButton {
    color: #6772e5;
}
.icon {
    height: 14px;
}
</style>
